mutation CreateUser(
  $email: String
  $salesforceId: String
  $firstName: String!
  $surname: String!
  $websiteProfile: WebsiteProfileInput!
  $pledge: PledgeInput
  $preventConfirmationEmail: Boolean!
  $welcomeEmailSource: String!
  $isPledger: Boolean!
) {
  createUser(
    input: {
      email: $email
      salesforceId: $salesforceId
      firstName: $firstName
      surname: $surname
      websiteProfile: $websiteProfile
      pledge: $pledge
      preventConfirmationEmail: $preventConfirmationEmail
      welcomeEmailSource: $welcomeEmailSource
      isPledger: $isPledger
    }
  ) {
    user {
      id
    }
  }
}
